"use client";
import { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  title: string;
  icon?: ReactNode;
}

export default function LocationCard(props: Props) {
  return (
    <div className="w-full h-[42px] font-bold px-4 py-3 bg-gray-secondary rounded-2xl justify-start items-center gap-2 inline-flex">
      <div className="flex gap-2 items-center w-full">
        {props.icon}

        <span className="text-sm line-clamp-1 text-ellipsis overflow-hidden whitespace-nowrap">
          {props.title}
        </span>
      </div>
    </div>
  );
}

export function LocationCardSkeleton() {
  return (
    <div className="custom-animate-pulse w-full h-[42px] font-bold px-4 py-3 bg-gray-secondary rounded-2xl justify-start items-center gap-2 inline-flex">
      <div className="flex gap-2 whitespace-nowrap items-center">
        <Skeleton className="w-8 h-8 rounded-full custom-animate-pulse" />

        <Skeleton className="w-40 h-4 custom-animate-pulse" />
      </div>
    </div>
  );
}
